import React from 'react';
import { Tag } from 'lucide-react';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from '../ui/dialog';

export const BulkTagDialog = ({
  open,
  onOpenChange,
  selectedContactCount,
  tags,
  selectedTagIds,
  onTagToggle,
  onAssign
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Tag className="w-5 h-5" />
            Assign Tags
          </DialogTitle>
          <DialogDescription>
            Assign tags to {selectedContactCount} selected contact{selectedContactCount !== 1 ? 's' : ''}
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            {tags.length === 0 ? (
              <p className="text-sm text-slate-500 text-center py-4">
                No tags created yet. Create tags first using "Manage Tags".
              </p>
            ) : (
              <div className="space-y-2">
                {tags.map(tag => (
                  <label
                    key={tag.id}
                    className="flex items-center gap-2 p-2 border rounded-lg hover:bg-slate-50 cursor-pointer"
                  >
                    <Checkbox
                      checked={selectedTagIds.includes(tag.id)}
                      onCheckedChange={(checked) => onTagToggle(tag.id, checked)}
                    />
                    <span
                      className="w-3 h-3 rounded-full"
                      style={{ backgroundColor: tag.color }}
                    />
                    <span className="text-sm">{tag.name}</span>
                  </label>
                ))}
              </div>
            )}
          </div>
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={onAssign}
            disabled={selectedTagIds.length === 0}
            className="bg-blue-600 hover:bg-blue-700"
          >
            Assign Tags
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BulkTagDialog;
